/**
 * Profile UI Helpers (Custom Selects, Resize Observers)
 */
export const initUI = () => {
    // Custom Select with delegated events
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.custom-select__trigger');
        const option = e.target.closest('.custom-select__option');
        const select = e.target.closest('.custom-select');

        if (trigger && select) {
            e.stopPropagation();
            document.querySelectorAll('.custom-select').forEach(s => {
                if (s !== select) s.classList.remove('is-open');
            });
            select.classList.toggle('is-open');
            return;
        }

        if (option && select) {
            e.stopPropagation();
            const value = option.dataset.value;
            const text = option.textContent.trim();
            const hiddenInput = select.querySelector('input[type="hidden"]');
            const label = select.querySelector('.custom-select__label');

            if (hiddenInput) {
                hiddenInput.value = value;
                hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            if (label) {
                label.textContent = text;
            }
            select.querySelectorAll('.custom-select__option').forEach(opt => opt.classList.remove('selected'));
            option.classList.add('selected');
            select.classList.remove('is-open');
            return;
        }

        // Click outside closes dropdowns
        document.querySelectorAll('.custom-select.is-open').forEach(s => s.classList.remove('is-open'));
    });

    // Content Expansion Observer
    const expansionObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            const item = entry.target.closest('.note-item, .saved-card');
            if (!item) return;
            const content = entry.target;
            const viewBtn = item.querySelector('.card-view-full-btn');
            
            // Note: entry.target.scrollHeight still causes reflow, 
            // but we can compare entry.contentRect.height with some fixed threshold 
            // or use a more efficient way to detect overflow.
            // Since ResizeObserver already gives us the height, let's use it.
            const currentHeight = entry.contentRect.height;
            
            // To detect overflow without reflow, we can use a small hack:
            // compare the height of the content element. 
            // Actually, scrollHeight is needed to know if it *would* be taller.
            // But we can do this inside requestAnimationFrame to batch it.
            
            requestAnimationFrame(() => {
                const isTruncated = content.scrollHeight > 185;
                if (viewBtn) {
                    viewBtn.style.display = isTruncated ? 'flex' : 'none';
                }
                content.classList.toggle('is-truncated', isTruncated);
            });
        });
    });

    document.querySelectorAll('.note-item, .saved-card').forEach(item => {
        const content = item.querySelector('.note-item__content, .saved-card__content');
        if (content) expansionObserver.observe(content);
    });
};
